import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "../store";
import { AuthPaths } from "../modules/authentication/authentication-routing.module";
import { selectActualAuthStatus } from "../store/auth/auth.reducer";
import { AuthStatus } from "../models/authentication";
import { map, take } from "rxjs";

@Injectable()
export class AuthGuard implements CanActivate {

    private router = inject(Router);
    private store = inject(Store<AppState>);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        return this.store.select(selectActualAuthStatus).pipe(
            take(1),
            map((authState) => {
                if (authState === AuthStatus.LoggedIn || (authState == AuthStatus.UnRegisteredUser && state.url == `/${AuthPaths.register}`)) {
                    return true;
                } else {
                    this.router.navigate([AuthPaths.signIn]);
                    return false;
                }
            })
        )
    }
}